import { HashRouter, Routes, Route } from 'react-router-dom';

import Header from 'components/layout/header/Header';
import Landing from 'pages/landing/Landing';
import OutcomeLabel from 'pages/outcome-label/OutcomeLabel';
import BetOfferLabel from 'pages/betOffer-label/BetOfferLabel';
import PotentialPayout from 'pages/potentialPayout/PotentialPayout';
import GetOriginalPotentialPayout from 'pages/potentialPayout/getOriginalPotentialPayout/GetOriginalPotentialPayout';
import SystemCombinations from 'pages/system-combinations/SystemCombinations';
import classes from './App.module.css';
import {
    GET_POTENTIAL_PAYOUT_ROUTE,
    ORIGINAL_POTENTIAL_PAYOUT_ROUTE,
    POTENTIAL_PAYOUT_ROUTE,
    POTENTIAL_PAYOUT_SYSTEM_ROUTE,
} from 'pages/potentialPayout/constants/PotentialPayoutConstants';
import CurrencyDisplay from 'pages/currency-display/CurrencyDisplay';
import GetPotentialPayout from 'pages/potentialPayout/getPotentialPayout/GetPotentialPayout';
import GetPotentialPayoutSystem from 'pages/potentialPayout/getPotentialPayoutSystem/GetPotentialPayoutSystem';
import OddsHelpers from 'pages/odds/Odds';
import OddsHelperView from 'components/odds/sub-components/OddsHelperView';
import { UtilsTypes } from 'constants/utilsTypes';
import {
    FORMAT_DECIMAL_ODDS_PATH,
    FORMAT_ODDS_PATH,
    GET_AMERICAN_ODDS_PATH,
    GET_FRACTIONAL_ODDS_PATH,
    GET_ODDS_TO_DECIMALS_PATH,
    getOddsUtilPath,
} from 'components/odds/constants/OddsUtilConstants';

const App = () => {
    const routes = (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/label/outcome/*" element={<OutcomeLabel />} />
            <Route path="/label/betOffer/*" element={<BetOfferLabel />} />
            <Route path="/currency-display/*" element={<CurrencyDisplay />} />
            <Route
                path={POTENTIAL_PAYOUT_ROUTE}
                element={<PotentialPayout />}
            />
            <Route
                path={`${POTENTIAL_PAYOUT_ROUTE}/${GET_POTENTIAL_PAYOUT_ROUTE}`}
                element={<GetPotentialPayout />}
            />
            <Route
                path={`${POTENTIAL_PAYOUT_ROUTE}/${ORIGINAL_POTENTIAL_PAYOUT_ROUTE}`}
                element={<GetOriginalPotentialPayout />}
            />
            <Route
                path={`${POTENTIAL_PAYOUT_ROUTE}/${POTENTIAL_PAYOUT_SYSTEM_ROUTE}`}
                element={<GetPotentialPayoutSystem />}
            />
            <Route
                path={`/system/combinations/*`}
                element={<SystemCombinations />}
            />
            <Route path={getOddsUtilPath('')} element={<OddsHelpers />} />
            <Route
                path={getOddsUtilPath(FORMAT_DECIMAL_ODDS_PATH)}
                element={
                    <OddsHelperView
                        type={UtilsTypes.FORMAT_DECIMAL_ODDS}
                        title={'Format decimal odds'}
                    />
                }
            />
            <Route
                path={getOddsUtilPath(FORMAT_ODDS_PATH)}
                element={
                    <OddsHelperView
                        type={UtilsTypes.FORMAT_ODDS}
                        title={'Format odds'}
                    />
                }
            />
            <Route
                path={getOddsUtilPath(GET_AMERICAN_ODDS_PATH)}
                element={
                    <OddsHelperView
                        type={UtilsTypes.GET_AMERICAN_ODDS}
                        title={'Get american odds'}
                    />
                }
            />
            <Route
                path={getOddsUtilPath(GET_FRACTIONAL_ODDS_PATH)}
                element={
                    <OddsHelperView
                        type={UtilsTypes.GET_FRACTIONAL_ODDS}
                        title={'Get fractional odds'}
                    />
                }
            />
            <Route
                path={getOddsUtilPath(GET_ODDS_TO_DECIMALS_PATH)}
                element={
                    <OddsHelperView
                        type={UtilsTypes.GET_ODDS_TO_DECIMALS}
                        title={'Get odds to two decimals'}
                    />
                }
            />
        </Routes>
    );

    return (
        <HashRouter>
            <div id="KambiUtil-wrapper">
                <Header />
                <div className={classes.Content}>{routes}</div>
            </div>
        </HashRouter>
    );
};

export default App;
